export default __webpack_public_path__ + "static/media/recording.0ed2caf9.svg";